module.exports = __webpack_public_path__ + "img/tyzx.759e1e78.png";